import React from "react";
const IconClock = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 1.95455C4.3834 1.95455 1.45455 4.8845 1.45455 8.5C1.45455 12.1155 4.3834 15.0455 8 15.0455C11.6142 15.0455 14.5455 12.1153 14.5455 8.5C14.5455 4.88467 11.6142 1.95455 8 1.95455ZM0 8.5C0 4.08135 3.57992 0.5 8 0.5C12.4174 0.5 16 4.08118 16 8.5C16 12.9188 12.4174 16.5 8 16.5C3.57992 16.5 0 12.9187 0 8.5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.68382 4.29443C8.08548 4.29443 8.41109 4.62004 8.41109 5.02171V8.18004L11.9697 11.4421C12.2658 11.7135 12.2858 12.1736 12.0144 12.4697C11.743 12.7658 11.2829 12.7858 10.9868 12.5143L7.19238 9.03608C7.0421 8.89833 6.95654 8.70383 6.95654 8.49997V5.02171C6.95654 4.62004 7.28215 4.29443 7.68382 4.29443Z"
      fill="currentColor"
    />
  </svg>
);
export default IconClock;
